// src/config/rolesDefaut.ts — SCE Issues
// Les rôles tels que le code les écrit (coordinateurs, BE, FNC-T, comptes
// invités, ouvertures), sous la forme du bloc `roles` du panneau
// d'administration (utils/roles). Sert de valeur par défaut à la lecture, et de
// point de départ au premier enregistrement depuis le panneau.

import { SUJETS, type Metier, type Sujet } from '@/types/issue.types'
import { METIERS_ROLES, type PersonneRole, type Roles } from '@/utils/roles'
import { COORDINATEURS_DEFAUT, SUPPLEANTS_DEFAUT } from './coordinateurs.config'
import { BE_PAR_METIER_DEFAUT, ENVOI_BE_OUVERT_DEFAUT } from './be.config'
import { AQ_CQ_DEFAUT, REVUE_FNCT_DEFAUT, TESTEURS_FNCT_DEFAUT } from './fnct.config'
import { COMPTES_ALIAS_DEFAUT, COMPTES_PARTAGES_DEFAUT } from './comptesAlias.config'
import { RESPONSABLES_SUJET_DEFAUT, SUJETS_OUVERTS_DEFAUT } from './sujets.config'
import { ACCUEIL_PERSO_OUVERT_DEFAUT } from './accueil.config'

const personne = (p: { nom: string; upn: string }): PersonneRole => ({ nom: p.nom, upn: p.upn.toLowerCase() })

function parMetier<T>(f: (m: Metier) => T): Record<Metier, T> {
  return Object.fromEntries(METIERS_ROLES.map((m) => [m, f(m)])) as Record<Metier, T>
}

export function rolesParDefaut(): Roles {
  return {
    version: 1,
    coordinateurs: parMetier((m) => ({
      titulaires: COORDINATEURS_DEFAUT[m].map(personne),
      suppleants: SUPPLEANTS_DEFAUT[m].map(personne),
    })),
    be: parMetier((m) => BE_PAR_METIER_DEFAUT[m].map(personne)),
    sujets: Object.fromEntries(SUJETS.map((s) => [s, RESPONSABLES_SUJET_DEFAUT[s].map(personne)])) as Record<Sujet, PersonneRole[]>,
    fnct: {
      testeurs: TESTEURS_FNCT_DEFAUT.map(personne),
      aqcq: AQ_CQ_DEFAUT.map(personne),
      revue: REVUE_FNCT_DEFAUT.map(personne),
    },
    externes: [],
    societes: [],
    appareils: COMPTES_PARTAGES_DEFAUT.map((a) => ({
      objectId: a.objectId.toLowerCase(),
      ...(a.empreinteAdresse ? { empreinteAdresse: a.empreinteAdresse } : {}),
      libelle: a.libelle,
      personnes: a.personnes.map(personne),
    })),
    secondaires: COMPTES_ALIAS_DEFAUT.map((c) => ({
      objectId: c.objectId.toLowerCase(),
      ...(c.empreinteAdresse ? { empreinteAdresse: c.empreinteAdresse } : {}),
      appareil: 'Téléphone personnel',
      personne: personne(c.principal),
    })),
    chefsProjet: [],
    ouvertures: { envoiBE: ENVOI_BE_OUVERT_DEFAUT, sujets: SUJETS_OUVERTS_DEFAUT, accueilPerso: ACCUEIL_PERSO_OUVERT_DEFAUT },
  }
}
